
<div>
    <v-row class="no-frame">
        <v-col class="no-frame mr-2">
            <f-date-picker
                :label            = "label"
                :time             = "false"
                v-model           = "data.beginDate"
                :rules            = "[ fromRule, ]"
                :error-messages   = "error.begin"
                :background-color = "background"
                @change           = "onStartChanged"
            />
        </v-col>
        <v-col class="no-frame ml-2">
            <f-date-picker
                :label            = "label2"
                :time             = "false"
                v-model           = "data.endDate"
                :rules            = "[toRule]"
                :error-messages   = "error.end"
                :background-color = "background"
                @change           = "onEndChanged"
            />
        </v-col>
    </v-row>
</div>
